export enum DBEmits {
    MUTATED = 'MUTATED',
    DELETED = 'DELETED',
    DONE = 'DONE',
    CLOSE = 'CLOSE',
    RESET = 'RESET',
    SAVE = 'SAVE',
    UPDATEMODELVALUE = 'UPDATEMODELVALUE',
    UPLOADMUTATED = 'UPLOADMUTATED',
    EXECACTION = 'EXECACTION',
    ADDNEW = 'ADDNEW',
    SEARCH = 'SEARCH',
    CLEARSEARCH = 'CLEARSEARCH',
    SEARCHMUTATED = 'SEARCHMUTATED',
    DELETE = 'DELETE',
    UPDATE = 'UPDATE',
    VIEW = 'VIEW',
    EDIT = 'EDIT',
    GOBACK = 'GOBACK',
    GONEXT = 'GONEXT',
    CONNECT = 'CONNECT',
    TABCHANGED = 'TABCHANGED',
    CLICK = 'CLICK',
    SELECTED = 'SELECTED',
    LINKSCHANGED = 'LINKSCHANGED',
    BLUR = 'BLUR',
    CLONE = 'CLONE',
    EXPORT = 'EXPORT',
}

export enum DBAction {
    EDIT = 'EDIT',
    CREATE = 'CREATE',
    DELETE = 'DELETE',
    VIEW = 'VIEW',
    ARCHIVE = 'ARCHIVE',
    LIST = 'LIST',
    EXPORT = 'EXPORT',
    DOWNLOAD = 'DOWNLOAD',
    SETPREFERRED = 'SETPREFERRED',
    SETDEFAULT = 'SETDEFAULT',
    CLONE = 'CLONE',
    RESTORE = 'RESTORE',
    ACTIVITY = 'ACTIVITY',
    DISABLE = 'DISABLE',
    ENABLE = 'ENABLE',
    MANAGE = 'MANAGE',
    DOSSIER = 'DOSSIER',
    SEARCH = 'SEARCH',

    CANCEL = 'CANCEL',
    CONFIRM = 'CONFIRM',
    CONNECT = 'CONNECT',
    INVITE = 'INVITE',
    SEND = 'SEND',
    OTHER1 = 'OTHER1',
    OTHER2 = 'OTHER2',
    VIEWMULTIPLE = 'VIEWMULTIPLE',
    EDITMULTIPLE = 'EDITMULTIPLE',
    CREATEMULTIPLE = 'CREATEMULTIPLE',
    DRAFT = 'DRAFT',
    COMPLETE = 'COMPLETE',
}